import { render, staticRenderFns } from "./orderList.vue?vue&type=template&id=6ea2a00a&scoped=true"
import script from "./orderList.vue?vue&type=script&lang=js"
export * from "./orderList.vue?vue&type=script&lang=js"
import style0 from "./orderList.vue?vue&type=style&index=0&id=6ea2a00a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea2a00a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\java\\project\\fenxijunya-java\\admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ea2a00a')) {
      api.createRecord('6ea2a00a', component.options)
    } else {
      api.reload('6ea2a00a', component.options)
    }
    module.hot.accept("./orderList.vue?vue&type=template&id=6ea2a00a&scoped=true", function () {
      api.rerender('6ea2a00a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mobile/orderStatistics/orderList.vue"
export default component.exports